export default "__VITE_ASSET__CpjVZ5Fk__"